module.exports = __webpack_public_path__ + "937c884f2fd28fb94cfdeec9945cd7c5.png";